module.exports = __webpack_public_path__ + "static/media/seabank.d6c55598.svg";